import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// Initialize i18n with async loading to prevent render-blocking
// Using requestIdleCallback or setTimeout to defer non-critical init
const initI18n = () => {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      lng: 'en',
      fallbackLng: 'en',
      debug: false,
      resources: messages,
      interpolation: {
        escapeValue: false,
      },
      // Prevent suspense during initialization
      react: {
        useSuspense: false,
      },
    });

  // Load admin content overrides from localStorage (deferred)
  try {
    const saved = localStorage.getItem('cms_overrides');
    if (saved) {
      const overrides = JSON.parse(saved) as Record<string, Record<string, string>>;
      Object.entries(overrides).forEach(([lang, content]) => {
        i18n.addResourceBundle(lang, 'translation', content, true, true);
      });
    }
  } catch {
    // Ignore localStorage errors
  }
};

// Defer initialization to prevent blocking initial render
if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
  window.requestIdleCallback(initI18n, { timeout: 100 });
} else {
  // Fallback for browsers without requestIdleCallback
  setTimeout(initI18n, 0);
}

export default i18n;
